import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import {
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";

function IncomingInvoiceContact({
  values,
  vendorContacts = [],
  title,
  setFieldValue,
  vendorContactDefault = false,
  handleVendorContactDefault,
}) {
  const [contactOptions, setContactOptions] = useState([]);
  useEffect(() => {
    setContactData(vendorContacts);
  }, [vendorContacts]);

  return (
    <Card>
      <Card.Header>
        <i className="fas fa-id-card-alt"></i>
        <span>
          <strong>{title} Contact</strong>
        </span>
      </Card.Header>
      <Card.Body>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <FormSelectField
              label="Contact Reference"
              name="contact"
              options={contactOptions}
              onSelectChange={(contactValue) => {
                setFieldValue("contact", contactValue);
                setFieldValue("contactName", contactValue.contactName);
                setFieldValue("position", contactValue.position);
                setFieldValue("contactPhone", contactValue.contactPhone);
                setFieldValue("contactEmail", contactValue.contactEmail);
              }}
            />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <FormTextField label="Contact Name" name="contactName" />
            <FormTextField label="Position" name="position" />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <FormTextField label="Phone Number" name="contactPhone" />
            <FormTextField label="Email" name="contactEmail" />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
  function setContactData(vendorContacts = []) {
    let contactOptionsTmp = [];
    contactOptionsTmp.push({
      value: {
        contact: {},
        contactName: "",
        position: "",
        contactPhone: "",
        contactEmail: "",
      },
      label: "No Reference",
    });
    if (typeof vendorContacts !== "undefined") {
      vendorContacts.map((vendorContact, index) => {
        contactOptionsTmp.push({
          value: vendorContact,
          label: vendorContact.contactName,
        });
        if (
          vendorContact.standardFlag === true &&
          vendorContactDefault === true &&
          values.ID === 0
        ) {
          setFieldValue("contact", vendorContact);
          setFieldValue("contactName", vendorContact.contactName);
          setFieldValue("position", vendorContact.position);
          setFieldValue("contactPhone", vendorContact.contactPhone);
          setFieldValue("contactEmail", vendorContact.contactEmail);
          handleVendorContactDefault();
        }
      });
    }
    setContactOptions(contactOptionsTmp);
  }
}

export default IncomingInvoiceContact;
